import store from "@/store";
import {ElMessage} from "element-plus";
import {createProjectFileBatch, getProjectFiles} from "@/api/file_info_sync";
import {fileStatusChange, isPathMatch, generateInputMarkdown} from "./utils"
import {fileUploadMD} from "@/components/file_process_js/pubilc_md/upload_md";
import {commonFileVisionMd, gerberFileVisionMd} from "@/components/file_process_js/pubilc_md/file_vision_md";
import {routerFilesAndDetectLayer} from "@/components/pcb/getGerberLayer"
import {getPreAnalyseMD} from "@/components/file_process_js/pubilc_md/pre_analyse_md";
import {getLabelParseMD} from "@/components/file_process_js/pubilc_md/file_label_exec";
import {getParseRuleResultMD} from "@/components/file_process_js/common_file_md/final_result_by_rule_md";
import {getTranslationMD} from "@/components/file_process_js/pubilc_md/translation_md";
import {OSS_BUCKET, VERSION_CONFIG} from '@/url_config';


function getProjectId(){
    return store.state.projectId;
}

function filterIgnoreFiles(fileList, filterConfig){
    const ignoreConfig = store.state.fileConfig.ignore_config
    const ignore_file_word_list = ignoreConfig.file_path_word
    const ignore_file_type_list = ignoreConfig.file_type

    // test
    // const label_to_param_config = store.state.mainConfig.label_to_param_config
    // for (let key in label_to_param_config) {
    //     const data = label_to_param_config[key]["labelKvParams"]
    //     // console.log("label_to_param_config data", data)
    //     console.log("key", generateInputMarkdown(data));
    // }

    let res = []
    fileList.forEach(fileInfo => {
        if (ignore_file_type_list.includes(fileInfo["file_type"]) ||isPathMatch(fileInfo.file_path, ignore_file_word_list)) {
            return
        }
        res.push(fileInfo);
    })
    return res
}

function addExtraAttr(fileInfo) {
    // 前端附加
    fileInfo['position_keys'] = {
        "common": [],
        "impedance": [],
        "structure": []
    }
    fileInfo['paramsMap'] = {}
    fileInfo['position_params'] = {
        "common": {"kvParams": [], "textParams": [], "tableParams": []},
        "impedance": {"kvParams": [], "textParams": [], "tableParams": []},
        "structure": {"kvParams": [], "textParams": [], "tableParams": []},
    }
    fileInfo['thumbnail'] = null   // 缩略图，仅做展示，不做逻辑参与
    fileInfo['vision_ratio'] = []

    fileInfo['file_image_keys'] = []   // 文件视觉成图
    fileInfo['translation_image_urls'] = []
    fileInfo['translation_detail'] = null
    fileInfo['translation_task_id'] = null

    fileInfo['language'] = []
    fileInfo['final_result'] = {} // 解析结果映射客户指定的key
    fileInfo['layer'] = ""   // gerber文件专属、解析层级
    fileInfo['boxProcessor'] = null //文件box 处理函数
    fileInfo['ManuResProcessor'] = null
    fileInfo['ManuRes'] = []
    fileInfo['AIRes'] = []

    fileInfo['position_keys'] = {
        "common": [],
        "impedance": [],
        "structure": []
    }
    fileInfo['paramsMap'] = {}
    fileInfo['position_params'] = {
        "common": {"kvParams": [], "textParams": [], "tableParams": []},
        "impedance": {"kvParams": [], "textParams": [], "tableParams": []},
        "structure": {"kvParams": [], "textParams": [], "tableParams": []},
    }
}

function formatFileKey(fileKey) {
    const f_key = fileKey.replaceAll("#", "_placeholder1_").replaceAll("%", "_placeholder2_")
    return `${store.state.projectId}/${f_key}`
    // return encodeURIComponent(fileKey)
}

export  async function syncProjectFile(filePath, mode, labels) {
    const projectId = getProjectId()
    try {
        const allFiles = await window.electronAPI.getFileListRecursion(filePath);

        if (allFiles.length > 50) {
            ElMessage.warning("请指定文件数量小于50的文件夹，避免出现操作卡死")
            return
        }
        const allFileList = []
        let fileSetLabels = []
        let filePerVisionLabels = []
        if (labels && labels.length > 0) {
            fileSetLabels = labels
            filePerVisionLabels = [labels]
        }
        let rootKey = store.state.filePath

        // todo 需要为每个文件追加一个错误栈
        allFiles.forEach(file => {
            const newFile = {}
            newFile['id'] = ""
            newFile['project_id'] = projectId
            newFile['root_key'] = rootKey
            newFile['name'] = file['name']
            newFile['file_path'] = file['path']
            newFile['file_key'] = formatFileKey(file['name'])
            newFile['file_hash'] = file['hash']
            newFile['file_type'] = file['type']
            newFile['file_size'] = file['size']

            newFile['file_vision'] = [] // 文件视觉信息，图片key，box，text
            newFile['labels'] = fileSetLabels
            newFile['labels_per_vision'] = filePerVisionLabels
            newFile['file_analyse_log'] = []
            newFile['file_pre_analyse'] = ""  //common 文件 预解析，包含文件有什么内容
            newFile['file_pre_analyse_log'] = []
            newFile['status'] = "init"
            newFile['status_code'] = 0
            newFile['select'] = false
            newFile['upload'] = false

            newFile['user'] = store.state.userName
            newFile['parse_result'] = {} // 解析结果映射 自建key
            newFile['final_result'] = {} // 解析结果映射客户指定的key

            newFile['text_content'] = [] //common 文件 文字识别
            newFile['version'] = VERSION_CONFIG.url_version

            // 前端附加
            addExtraAttr(newFile)

            allFileList.push(newFile)
        })
        console.log("allFileList", allFileList)
        const allowFiles = filterIgnoreFiles(allFileList)
        const [commonList, gbrList] = await routerFilesAndDetectLayer(allowFiles)
        console.log("init gbr common list", commonList, gbrList)
        if (mode==="init") {
            store.commit('setProjectFileList', allowFiles)
            store.commit('setCommonObjList', commonList)
            store.commit('setGerberObjList', gbrList)
        } else if (mode==="add") {
            store.commit('addProjectFileList', allowFiles)
            store.commit('addCommonObjList', commonList)
            store.commit('addGerberObjList', gbrList)
        }

        // const commonKeywords = await store.dispatch('getCommonKeywords')
        // todo 这里需要修改为远程已有历史信息，需要返回本地同步，为历史回放模式铺垫
        syncFileInfo(allowFiles).then(success => {
            allowFiles.forEach(fileInfo => {
                fileStatusChange(fileInfo)
            })
            // 暂时 主观屏蔽gbr， 可以通过手动添加的方式添加
            fileProcess(commonList, gbrList)
        }).catch(error => {
            ElMessage.warning(`建立远程信息同步出现未知错误； 将影响普通文件ai解析，稍后请重新打开文件/文件夹重试，或联系研发`)
            console.error(`建立远程信息同步出现未知错误, 错误详情：[${error}]`)
        })
    } catch (error) {
        console.error("Failed to sync file info", error);
        store.commit('setConfig', []); // 如果失败，保持默认的空数组
    }

}


function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

function deepMerge(target, source) {
    if (!isObject(target) || !isObject(source)) {
        return source; // 如果不是对象，直接返回源
    }

    Object.keys(source).forEach(key => {
        const targetValue = target[key];
        const sourceValue = source[key];

        if (isObject(targetValue) && isObject(sourceValue)) {
            // 如果两个值都是对象，则递归合并
            target[key] = deepMerge(targetValue, sourceValue);
        } else {
            // 否则，直接赋值（在Vue中，这会触发响应式更新）
            target[key] = sourceValue;
        }
    });
    return target;
}

async function syncFileInfo(fileList) {
    const project_id = store.state.projectId
    const root_key = store.state.filePath
    if (!project_id) {
        return false
    }
    const syncResList = await createProjectFileBatch(project_id, root_key, fileList)
    console.log("syncResList", syncResList)
    for (let i=0; i < fileList.length; i++) {
        if (syncResList[i]) {
            deepMerge(fileList[i], syncResList[i]);
        }
    }
    return true
}

async function refreshLastProjectInfo(fileList) {
    if (!fileList) {
        return false
    }

    const project_id = fileList[0].project_id
    if (!project_id) {
        return false
    }
    const syncResList = await getProjectFiles(project_id)
    console.log("syncResList", syncResList)
    for (let i=0; i < fileList.length; i++) {
        for (let j=0; j<syncResList.length; j++) {
            if (syncResList[j].file_path === fileList[i].file_path) {
                deepMerge(fileList[i], syncResList[j]);
                break
            }
        }
    }
    return true
}

function tempAddFilePath(fileInfo) {
    fileInfo['file_path'] = `${fileInfo['root_key']}\\${fileInfo['file_key']}`
}

export async function ReplayByProjectId(project_id) {
    const remoteFiles = await getProjectFiles(project_id)
    const commonList= []
    const gbrList = []

    remoteFiles.forEach(fileInfo => {

        tempAddFilePath(fileInfo)
        addExtraAttr(fileInfo)

        if(fileInfo.file_type === "gbr"){
            gbrList.push(fileInfo)
        } else {
            commonList.push(fileInfo)
        }
    })

    store.commit('setProjectFileList', remoteFiles)
    store.commit('setCommonObjList', commonList)
    store.commit('setGerberObjList', gbrList)

    fileProcess(commonList, gbrList)

    return remoteFiles
}



async function asyncExc(mds, fileInfo) {
    for (let i=0; i < mds.length; i++) {
        const processMDObj = mds[i]
        if (processMDObj.md){
            // console.log("start processMD", mds, i)
            if (processMDObj.blocking){
                await processMDObj.md(fileInfo)
            } else {
                processMDObj.md(fileInfo)
            }
            // console.log("res processMDs", mds, i)
        }
    }
}


/**
 * 为单个文件创建一个完整的、独立的、从预处理到后处理的流水线。
 * @param {object} fileInfo - 要处理的文件信息
 * @param {Array<Function>} preProcessMDs - 用于此文件的预处理中间件
 */
async function processSingleFilePipeline(fileInfo, preProcessMDs) {
    try {
        // --- 第 1 步：执行预处理并等待其完成 ---
        console.log(`[${fileInfo.name}] Pipeline started, running pre-process...`);
        await asyncExc(preProcessMDs, fileInfo);
        console.log(`[${fileInfo.name}] Pre-process finished.`);

        // --- 第 2 步：立即开始后处理（非阻塞/“发射后不管”） ---
        // 注意：这里的后处理逻辑和你原来的 forEach 行为完全一致。
        // 它会启动，但 processSingleFilePipeline 函数本身不会等待它完成。
        const postProcessMDObjs = [
            {"md":getParseRuleResultMD(fileInfo), "blocking": true},
            {"md":getPreAnalyseMD(fileInfo), "blocking": true},
            {"md":getTranslationMD(fileInfo), "blocking": false},
            {"md":getLabelParseMD(fileInfo), "blocking": true},
        ];

        console.log(`[${fileInfo.name}] Starting post-process (fire and forget)...`);
        asyncExc(postProcessMDObjs, fileInfo);

    } catch (error) {
        // 这个 try-catch 只能捕获到预处理（await asyncExc）阶段的错误
        console.error(`Error in pre-processing pipeline for ${fileInfo.name}:`, error);
        // 你可以在这里添加逻辑，比如标记该文件处理失败
    }
}

async function fileProcess(commonFileList, gerberFileList) {
    /*
        新逻辑:
        为每个文件并行启动一个独立的、从头到尾的处理流水线。
        主函数不等待任何一个流水线完成，实现完全的“发射后不管”启动。
    */
    console.log("Starting to launch processing pipelines for all files...");

    const commonPreMDs = [
        {"md":fileUploadMD, "blocking": true},
        {"md":commonFileVisionMd, "blocking": true},
    ];
    const gerberPreMDs = [
        {"md":fileUploadMD, "blocking": true},
        {"md":gerberFileVisionMd, "blocking": true},
    ];

    // 为 commonFileList 中的每个文件启动一个流水线
    commonFileList.forEach(fileInfo => {
        processSingleFilePipeline(fileInfo, commonPreMDs);
    });

    // 为 gerberFileList 中的每个文件启动一个流水线
    gerberFileList.forEach(fileInfo => {

        fileStatusChange(fileInfo, "closed", -100)
        // processSingleFilePipeline(fileInfo, gerberPreMDs);
    });

    console.log("All file processing pipelines have been launched.");
    // fileProcess 函数在这里立即结束，所有文件的处理都在后台并行进行。
}

// 重新解析
export async function fileReProcess(fileInfo) {

    const statusCode = fileInfo.status_code;
    if (statusCode > 0 ) {
        return
    }
    const newStatusCode = Math.floor(-statusCode/100) * 100 + 1;
    console.log("fileReProcess statusCode, newStatusCode", fileInfo, statusCode, newStatusCode)
    fileInfo.status_code = newStatusCode;
    fileInfo.status = "reprocessing";
    fileProcess([fileInfo], [])
}

export async function refreshAllFile() {
    const allowFiles = store.state.projectFileList;
    const commonList = store.state.commonObjList;
    const gbrList = store.state.gerberObjList;


    const needFreshList = []
    allowFiles.forEach(fileInfo => {
        if (fileInfo.status_code < 399 && fileInfo.status_code > 0) {
            needFreshList.push(fileInfo);
        }
    })

    const selectMap = {}
    needFreshList.forEach(fileInfo => {
        // 重置前端其他要求，保留勾选
        // addExtraAttr(fileInfo)
        selectMap[fileInfo.file_path] = fileInfo.select;
    })

    try {
        const success = await syncFileInfo(needFreshList);
        if (!success) {
            throw new Error('建立远程信息同步出现未知错误.');
        }
        needFreshList.forEach(fileInfo => {
            fileStatusChange(fileInfo);
            fileInfo.select = selectMap[fileInfo.file_path]
            console.log("fileInfo.select", fileInfo.name, fileInfo.select, fileInfo);
        });

        ElMessage.success('文件状态刷新成功！');
        console.log("refreshAllFile", commonList);
        fileProcess(needFreshList, gbrList);
        return true;
    } catch (error) {
        ElMessage.warning(`建立远程信息同步出现未知错误； 将影响普通文件ai解析，稍后请重新打开文件/文件夹重试，或联系研发`);
        console.error(`建立远程信息同步出现未知错误, 错误详情：[${error}]`);
        throw error;
    }
}

export async function refreshAllFileV2() {
    const allowFiles = store.state.projectFileList;
    const selectMap = {}
    allowFiles.forEach(fileInfo => {
        // 重置前端其他要求，保留勾选
        // addExtraAttr(fileInfo)
        selectMap[fileInfo.file_path] = fileInfo.select;
    })


    try {
        const ok = await refreshLastProjectInfo(allowFiles);
        if (!ok) {
            ElMessage.warning(`刷新失败`);
        }
        allowFiles.forEach(fileInfo => {
            fileStatusChange(fileInfo);
            fileInfo.select = selectMap[fileInfo.file_path]
            console.log("fileInfo.select", fileInfo.name, fileInfo.select, fileInfo);
        });

        ElMessage.success('文件状态刷新成功！');
        fileProcess(allowFiles, []);
        return true;
    } catch (error) {
        ElMessage.warning(`建立远程信息同步出现未知错误； 将影响普通文件ai解析，稍后请重新打开文件/文件夹重试，或联系研发`);
        console.error(`建立远程信息同步出现未知错误, 错误详情：[${error}]`);
        throw error;
    }
}